import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-work-space",
  "use": "icon-work-space-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-work-space\">\n\t<g fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\">\n\t\t<path d=\"M12 2L3 7l9 5l9-5z\" />\n\t\t<path d=\"M2 11.545L12 17l10-5.455\" />\n\t\t<path d=\"M22 16.545L12 22L2 16.545\" />\n\t</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol